
import { Component, Vue, Emit } from "vue-property-decorator";
import { systemSrv } from "./../services/system";
import store from "./../store";
import Header from "../components/common/Header.vue";
import Footer from "../components/common/Footer.vue";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import { notiSrv } from "./../services/noti";
import { httpService } from "./../services/http";
import SideMenu from "@/components/common/SideMenu.vue";

@Component({
  components: {
    Footer,
    SideMenu
  }
})
export default class Welcome extends Vue {
  profile = systemSrv.profile;
  activate;
  profileName = "";

  data = {
    campaigns: []
  };

  constructor() {
    super();
  }
  async created() {
    this.profile = systemSrv.profile;
    if (this.profile && this.profile["name"]) {
      this.profileName = this.profile["name"];
    }

    //this.data['campaigns'] = await httpService.getCampaigns()
    //console.log("this.data['campaigns']",this.data['campaigns'])
    window.scrollTo(0, 0);
  }
  smartParking(){
    router.push('smart_parking');
  }
  leoCubs(){
    router.push('leocubs');
  }
  get menuOpen() {
    return store.state.menu.open;
  }

  //@Emit('menuState')
  activateSideMenu(activate) {
    console.log("activate", activate);
    this.activate = activate;
    //this.$emit('menuStateChanged', true)
    notiSrv.activateSideMenu(activate);
  }
  // activateSideMenu(activate){
  //   console.log("activating",activate)
  //   //notiSrv.activateSideMenu(activate)
  // }
}
